import { create } from 'zustand'

interface ProjectStore {
  activeProjectId: number | null
  showUploadModal: boolean
  showNewSpeakerModal: boolean
  showNewProjectModal: boolean
  showAddPromptModal: boolean
  showEditWithAI: boolean
  showTrialStartedModal: boolean
  showTrialEndingModal: boolean
  showUpgradeTrialModal: boolean
  showPricingModal: boolean
  showConfetti: boolean
  showToastyV2Modal: boolean
  showOutcastRebrandModal: boolean
  selectedPlanId: string | null
  setShowUploadModal: (show: boolean) => void
  setActiveProjectId: (project: number) => void
  setShowNewSpeakerModal: (show: boolean) => void
  setShowNewProjectModal: (show: boolean) => void
  setShowAddPromptModal: (show: boolean) => void
  setShowEditWithAI: (show: boolean) => void
  setShowTrialStartedModal: (show: boolean) => void
  setShowTrialEndingModal: (show: boolean) => void
  setShowUpgradeTrialModal: (show: boolean) => void
  setShowPricingModal: (show: boolean) => void
  setShowConfetti: (show: boolean) => void
  setShowToastyV2Modal: (show: boolean) => void
  setShowOutcastRebrandModal: (show: boolean) => void
  setSelectedPlanId: (id: string | null) => void
  reset: () => void
}

export const useProjectStore = create<ProjectStore>((set, get) => ({
  activeProjectId: null,
  showOutcastRebrandModal: false,
  showUploadModal: false,
  showNewSpeakerModal: false,
  showNewProjectModal: false,
  showAddPromptModal: false,
  showEditWithAI: false,
  showTrialStartedModal: false,
  showTrialEndingModal: false,
  showUpgradeTrialModal: false,
  showPricingModal: false,
  showConfetti: false,
  showToastyV2Modal: false,
  selectedPlanId: null,
  setShowOutcastRebrandModal: (show: boolean) =>
    set({ showOutcastRebrandModal: show }),
  setShowNewProjectModal: (show: boolean) => set({ showNewProjectModal: show }),
  setShowAddPromptModal: (show: boolean) => set({ showAddPromptModal: show }),
  setShowEditWithAI: (show: boolean) => set({ showEditWithAI: show }),
  setActiveProjectId: (projectId: number) =>
    set({ activeProjectId: projectId }),
  setShowUploadModal: (show: boolean) => set({ showUploadModal: show }),
  setShowNewSpeakerModal: (show: boolean) => set({ showNewSpeakerModal: show }),
  setShowTrialStartedModal: (show: boolean) =>
    set({ showTrialStartedModal: show }),
  setShowTrialEndingModal: (show: boolean) =>
    set({ showTrialEndingModal: show }),
  setShowUpgradeTrialModal: (show: boolean) =>
    set({ showUpgradeTrialModal: show }),
  setShowPricingModal: (show: boolean) => set({ showPricingModal: show }),
  setShowConfetti: (show: boolean) => set({ showConfetti: show }),
  setShowToastyV2Modal: (show: boolean) => set({ showToastyV2Modal: show }),
  setSelectedPlanId: (id: string | null) => set({ selectedPlanId: id }),
  reset: () =>
    set({
      showConfetti: false,
    }),
}))
